<template>
  <footer>
    <!-- start navbar -->
    <div class="navbar navbar-default navbar-inverse navbar-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="navbar-header">
              <router-link to="/" class="navbar-brand" title="Logo">
                <img src="/images/logo-reg.png" alt="Logo"> Your neighborhood just got friendly!
              </router-link>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <ul class="nav navbar-nav navbar-right">
              <li><router-link to="/about" title="About Us"> About Us</router-link></li>
              <li><router-link to="/contact" title="Contact Us"> Contact Us</router-link></li>
              <li><router-link to="/terms" title="Terms of Service"> Terms of Service</router-link></li>
              <li><router-link to="/privacy" title="Privacy Policy"> Privacy Policy</router-link></li>
            </ul>
            <div class="clearfix"></div>
            <p class="copy text-right">
              &copy; Copyright 2013 - {{ currentYear }} Pennywell Corporation. All Rights Reserved.  /
              <router-link to="/dmca" title="DMCA Copyright Information">DMCA Copyright Information</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- end navbar -->
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
/* Footer styles are inherited from the main CSS */

/* Mobile responsive padding for navigation links */
@media (max-width: 768px) {
  .navbar-nav.navbar-right {
    padding-left: 15px;
  }

  .copy.text-right {
    padding-left: 15px;
  }
}
</style>